module.exports = __webpack_public_path__ + "img/vertical_5_1_5010.1176b48d.png";